import { removeWorkSpaceTab } from '../utils/helper/helper'

import * as routesNames from '../routes/routeName'
import * as Icons from '../assets/svg/icons'

export const token = 'authToken'
export const moreComments = 'more'
export const previousCommentsReply = 'previous'

export const createNavigationButtonsWithTooltips = [
	// { route: routesNames.pharmacy_tasks_list, icon: <Icons.TaskAssignIcon />, tooltipsValue: 'Tasks Assignments' },
	{ route: routesNames.ALLREQUEST_ROUTE, icon: <Icons.HeaderTimeOffRequestIcon />, tooltipsValue: 'Time Off Request' },
	{ route: routesNames.APPRECIATIONS_ROUTE, icon: <Icons.HeaderAppreciationsIcons />, tooltipsValue: 'Appreciations' },
	// { route: routesNames.ALLEMPLOYEES_ROUTE, icon: <Icons.HeaderTeamsIcon />, tooltipsValue: 'Team' },
	{ route: routesNames.SETTINGS_ROUTE, icon: <Icons.HeaderSettingIcons />, tooltipsValue: 'Settings' },
	{ route: routesNames.pharmacy_all_notifications, icon: <Icons.BellIcon />, tooltipsValue: 'All Notifications' }
];

/**
 * The avatar menu (top-right). Each entry now carries the `route` it navigates
 * to so the header can run it through the SAME module gate as the top nav and
 * the sidebar (navItemAllowed + buildModuleGate) instead of a second, private
 * copy of the rules. Entries whose route is not part of the module contract
 * (My Profile, Time Sheets, Settings) have no sub-module key, so the gate
 * passes them exactly as today; "Team" points at a real module page and is the
 * one that was leaking.
 * Logout has no route on purpose — it must never be gated away.
 */
export const HeaderdropDownItems = (navigate, setDropdownOpen, setModalOpen, isModalOpen, adminModule) => [
	{
		label: "My Profile",
		route: routesNames.MY_PROFILE,
		icon: <Icons.ProfileIcon />,
		onClick: () => { navigate(routesNames.MY_PROFILE); removeWorkSpaceTab(); }
	},
	{
		label: "Time Sheets",
		route: routesNames.TIMESHEET_ROUTE,
		icon: <Icons.TimeSheetIcon />,
		onClick: () => { navigate(routesNames.TIMESHEET_ROUTE); removeWorkSpaceTab(); }
	},
	...(adminModule === 1 ? [{
		label: "Team",
		route: routesNames.pharmacy_user,
		icon: <svg width="24" height="24" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M5.0618 4.81026C4.38764 4.81026 3.82584 5.40855 3.82584 6.1265C3.82584 6.84444 4.38764 7.44273 5.0618 7.44273C5.73596 7.44273 6.29775 6.84444 6.29775 6.1265C6.29775 5.40855 5.71348 4.81026 5.0618 4.81026ZM5.0618 8.30427C3.9382 8.30427 3.03933 7.32308 3.03933 6.1265C3.03933 4.92991 3.96067 3.94872 5.0618 3.94872C6.18539 3.94872 7.08427 4.92991 7.08427 6.1265C7.08427 7.32308 6.16292 8.30427 5.0618 8.30427ZM15.9382 4.97778C15.264 4.97778 14.7022 5.57607 14.7022 6.29402C14.7022 7.01197 15.264 7.61026 15.9382 7.61026C16.6124 7.61026 17.1742 7.01197 17.1742 6.29402C17.1742 5.57607 16.6124 4.97778 15.9382 4.97778ZM15.9382 8.4718C14.8146 8.4718 13.9157 7.4906 13.9157 6.29402C13.9157 5.09744 14.8371 4.11624 15.9382 4.11624C17.0618 4.11624 17.9607 5.09744 17.9607 6.29402C17.9831 7.4906 17.0618 8.4718 15.9382 8.4718ZM1.55618 11.5111V14.9094L3.66854 16.2256V12.0855C3.66854 11.3915 4.09551 10.7692 4.83708 10.2427C2.67977 10.3385 1.55618 11.1521 1.55618 11.5111ZM10.1854 20.4137L15.7135 17.0598L17.3371 16.0547V12.1573C17.3371 11.4393 16.8876 10.7932 16.1011 10.2667C18.2584 10.3385 19.4045 11.1521 19.4045 11.535V15.6034L10.5 21.011L10.1854 20.4137ZM10.5 3.11111C11.7978 3.11111 12.8539 4.21966 12.8539 5.5897C12.8539 6.95974 11.7978 8.06838 10.5 8.06838C9.20225 8.06838 8.14607 6.95974 8.14607 5.5897C8.14607 4.21966 9.20225 3.11111 10.5 3.11111ZM10.5 8.9299C12.2135 8.9299 13.6404 7.42735 13.6404 5.5897C13.6404 3.75214 12.2135 2.24957 10.5 2.24957C8.78652 2.24957 7.35955 3.75214 7.35955 5.5897C7.35955 7.42735 8.78652 8.9299 10.5 8.9299ZM5.26404 12.0855V17.6068L10.5 20.7761L15.7584 17.6068V12.0855C15.7584 10.6256 13.3933 9.45299 10.5 9.45299C7.62921 9.45299 5.26404 10.6256 5.26404 12.0855Z" fill="#757575"/>
		</svg>,
		onClick: () => { navigate(routesNames.pharmacy_user); removeWorkSpaceTab(); }
	}] : []),
	{
		label: "Settings",
		route: routesNames.SETTINGS_ROUTE,
		icon: <Icons.SettingIcon />,
		onClick: () => { navigate(routesNames.SETTINGS_ROUTE); removeWorkSpaceTab(); }
	},
	// {
	// 	label: "Label to Margin",
	// 	icon: <Icons.SettingIcon />,
	// 	onClick: () => { navigate(routesNames.SETTINGS_ROUTE); removeWorkSpaceTab(); }
	// },
	{
		label: "Logout",
		icon: <Icons.LogOutIcon />,
		onClick: () => { setModalOpen(!isModalOpen); setDropdownOpen(false); }
	}
]

export const dispenseRecurrenceValues = [{ name: 'Daily' }, { name: 'Every Monday' },
{ name: 'Every Tuesday' }, { name: 'Every Wednesday' }, { name: 'Every Thursday' },
{ name: 'Every Friday' }, { name: 'Every Saturday' }, { name: 'Every Sunday' }]
